import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { StatusColorSchema } from '@/config/statuses.config';
import { Pill } from '@/components/common/Pill/Pill';

export interface AgGridStatusParams {
  statusColorSchema: StatusColorSchema;
}

interface IAgGridStatusProps extends AgGridStatusParams, ICellRendererParams { }

export default function AgGridStatus({ value, valueFormatted, statusColorSchema }: IAgGridStatusProps) {
  const valueToShowInsidePill = valueFormatted ?? value;

  return (
    <Pill background={statusColorSchema[value]}>
      {valueToShowInsidePill ?? '-'}
    </Pill>
  );
}
